import Video from "../../video/video__mob.mp4";
import Poster from "../../images/poster.jpg";

export const VideoMobile = () => {
  return (
    <div className="video__block-mobile">
      <video
        className="video"
        src={Video}
        playsInline
        autoPlay
        muted
        loop
        poster={Poster}
      />
    </div>
  );
};
